import { render, staticRenderFns } from "./ExplicitTopicRecommendationsWidget.vue?vue&type=template&id=66a9122c&"
import script from "./ExplicitTopicRecommendationsWidget.vue?vue&type=script&lang=js&"
export * from "./ExplicitTopicRecommendationsWidget.vue?vue&type=script&lang=js&"
import style0 from "./ExplicitTopicRecommendationsWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "../locales/common.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Fbig-dig-data%2Fshaft%2Fdesign%2Fshaft-ui%2Fsrc%2Fcomponents%2FExplicitTopicRecommendationsWidget.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./ExplicitTopicRecommendationsWidget.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VContainer,VDataTable,VRow,VSelect})
